import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';

const Image = ({ src, alt, role = 'presentation', className }) => {
  return <img src={src} alt={alt} role={role} className={className} loading="lazy" />;
};

const BeginButton = ({ children, className }) => {
  return (
    <a href="/survey" className={`justify-center px-9 py-3 mt-16 animate-fadeIn leading-9 text-white whitespace-nowrap bg-[#7035de] shadow-sm rounded-full max-md:px-5 max-md:mt-10 ${className}`} tabIndex="0">
      {children}
    </a>
  );
};

function JourneyStartPage() {
  const [Instructions, setInstructionsText] = useState([]);

  useEffect(() => {
    const fetchPersonalityTypes = async () => {
      const token = "0585347c92a761c69f60773b0f289cb06dd4991780b517d0507ba7aa0bf8376ed6f48430e4ba332e655dc74b160ffc9ca92ea050b4c8e6c2e4c7bba93feea72fbb3060d118edab771c12f9886eb8837093bdc73d6a145495dc387a2fe026b1ad99ae6ae35ccba3709a7838bba459431f3464176a9e363e34c43d97adddb0f9d0";
      try {
        const response = await axios.get('http://localhost:1331/api/question-instruction',
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        console.log(response.data.data)
        setPersonalityTypes(response.data.data);
      } catch (error) {
        console.error('Error fetching personality types:', error);
      }
    };

    fetchPersonalityTypes();
  }, []);

  return (
    <main className="flex flex-col justify-center font-bold text-center text-gray-800">
      <section className="flex overflow-hidden relative flex-col justify-center w-full max-md:max-w-full">
        <div className="flex flex-col flex-1 items-center self-stretch max-md:max-w-full">
          <a href="/"><Image src="TS-Logov3.png" alt="Icon 2" className="h-36  m-5 border-white object-cover transition-transform duration-300 group-hover:scale-105" /></a>
          <h1 className='text-black'>Introduction</h1>
          <div className="font-poppins w-3/4 sm:w-1/2 mt-6 text-black">
            Discover your personality type in just 15-20 minutes with our scientific assessment based on the Objective Personality system. Discover which of the 32 archetypes you are! It's free—no email required.
          </div>
          <div className='bg-white shadow-md shadow-[#7035de] p-8 rounded-md my-24 mx-8'>
            <h1 className="text-black">Instructions</h1>
            <div className="text-black mt-6">
              <p>
                If someone is watching you take the test, or you are hungry, sad, tired, or otherwise not in a normal mood, it is better to stop now and save this test for later.
                Usually your first impulse is correct, or else it's better to consider your natural inclinations early in life more than how you are now.
                Answer each question according to your natural self and what was most true for most of your early life. Try to ignore your upbringing, trauma, and cultural influences.
                Also think how parents, friends, and ex's would answer for you. Be completely honest. There are no good/bad or right/wrong answers.
              </p>
            </div>
          </div>
          <BeginButton className="transition ease-in-out delay-150 hover:scale-105 mb-24">Begin Your Journey</BeginButton>
        </div>
      </section>
    </main>
  );
}

export default JourneyStartPage;